var map = {
	".": 336,
	"./": 336,
	"./Clutch": 1056,
	"./Clutch.js": 1056,
	"./Component": 1057,
	"./Component.js": 1057,
	"./Form": 769,
	"./Form.js": 769,
	"./OldUi": 1058,
	"./OldUi.js": 1058,
	"./RenderComponent": 770,
	"./RenderComponent.js": 770,
	"./SpireonNew": 1059,
	"./SpireonNew.js": 1059,
	"./SpireonOld": 1060,
	"./SpireonOld.js": 1060,
	"./TopActions": 768,
	"./TopActions.js": 768,
	"./index": 336,
	"./index.js": 336,
	"./style": 172,
	"./style.js": 172
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4156;
module.exports = webpackAsyncContext;